import { render, staticRenderFns } from "./addExpense.vue?vue&type=template&id=778bd228&scoped=true&"
import script from "./addExpense.vue?vue&type=script&lang=js&"
export * from "./addExpense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778bd228",
  null
  
)

export default component.exports